import React from 'react';
import InfiniteScroll from 'components/shared/infiniteScroll/presentational/InfiniteScroll';
import { Payee } from 'lib/type';

interface PayeeInfiniteScrollProps {
    data: Payee[];
    onPayeeClick: (payee: any) => void;
}

const PayeeInfiniteScroll = ({
    data,
    onPayeeClick,
}: PayeeInfiniteScrollProps) => {
    return (
        <div className="uk-payee-container">
            <InfiniteScroll
                className="uk-payee-list-container"
                size="small"
            >
                {data?.map(payee => {
                    return (
                        <button
                            onClick={() => onPayeeClick(payee)}
                            key={payee.id}
                            className="uk-payee-item clickable"
                            type="button"
                        >
                            <div className="item-left">
                                <h1 className="uk-payee-name">
                                    {payee.payeeName}
                                </h1>
                                <div className="uk-payee-account">
                                    <p>{payee.accountNo}</p>
                                    <span>|</span>
                                    <p>{payee.sortCode}</p>
                                </div>
                            </div>
                        </button>
                    );
                })}
            </InfiniteScroll>
        </div>
    );
};

export default PayeeInfiniteScroll;
